var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { Grid } from '@mui/material';
import { isFalsy } from '../../../utils/common';
import AccordionWrapper from './AccordionWrapper';
import { isFalsyOrZero } from './constants';
import SectionHeader from './SectionHeader';
import { COMPONENT_ID_ENUM } from './types';
var AdditionalExamRequirement = function (_a) {
    var _b, _c, _d, _e, _f;
    var additionalExams = _a.additionalExams, courseDetails = _a.courseDetails;
    var getAdditionalExamDetails = function () {
        var details = [];
        additionalExams === null || additionalExams === void 0 ? void 0 : additionalExams.forEach(function (exam) {
            var sectionalScoresPresent = !isFalsyOrZero(exam === null || exam === void 0 ? void 0 : exam.quantitativeScore) || !isFalsyOrZero(exam === null || exam === void 0 ? void 0 : exam.verbalScore);
            if (sectionalScoresPresent || !isFalsyOrZero(exam === null || exam === void 0 ? void 0 : exam.overAllScore)) {
                details === null || details === void 0 ? void 0 : details.push({
                    examType: exam === null || exam === void 0 ? void 0 : exam.examType,
                    overallScore: !isFalsyOrZero(exam === null || exam === void 0 ? void 0 : exam.overAllScore) ? exam === null || exam === void 0 ? void 0 : exam.overAllScore : undefined,
                    examTitle: exam === null || exam === void 0 ? void 0 : exam.examType,
                    sectionalScores: [
                        {
                            label: 'Quantitative',
                            value: !isFalsyOrZero(exam === null || exam === void 0 ? void 0 : exam.quantitativeScore) ? exam === null || exam === void 0 ? void 0 : exam.quantitativeScore : ''
                        },
                        {
                            label: 'Verbal',
                            value: !isFalsyOrZero(exam === null || exam === void 0 ? void 0 : exam.verbalScore) ? exam === null || exam === void 0 ? void 0 : exam.verbalScore : ''
                        }
                    ],
                    preventAccordionExpand: !sectionalScoresPresent,
                    examRequiredType: (exam === null || exam === void 0 ? void 0 : exam.examRequiredValue) === 'YES'
                        ? 'REQUIRED'
                        : (exam === null || exam === void 0 ? void 0 : exam.examRequiredValue) === 'GOOD_TO_HAVE'
                            ? 'GOOD_TO_HAVE'
                            : undefined
                });
            }
        });
        return details;
    };
    var isMainEntryRequirementPresent = !isFalsy((_c = (_b = courseDetails === null || courseDetails === void 0 ? void 0 : courseDetails.mainEntryRequirement) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.gapYear) ||
        !isFalsy((_e = (_d = courseDetails === null || courseDetails === void 0 ? void 0 : courseDetails.mainEntryRequirement) === null || _d === void 0 ? void 0 : _d[0]) === null || _e === void 0 ? void 0 : _e.workExperienceRequired);
    if (isFalsyOrZero(getAdditionalExamDetails()) && !isMainEntryRequirementPresent)
        return null;
    return (React.createElement("div", { className: "lfc-bg-white lfc-p-3 lg:lfc-p-4 lfc-rounded-lg", id: COMPONENT_ID_ENUM.COURSE_DETAILS_ADDITIONAL_REQUIREMENT },
        React.createElement(SectionHeader, { title: "Additional Requirements" }),
        React.createElement(Grid, { container: true, spacing: 4 }, (_f = getAdditionalExamDetails()) === null || _f === void 0 ? void 0 :
            _f.map(function (exam, index) {
                return (React.createElement(Grid, { item: true, key: index, xs: 12, lg: 6 },
                    React.createElement(AccordionWrapper, __assign({}, exam))));
            }),
            isMainEntryRequirementPresent ? (React.createElement(Grid, { item: true, xs: 12 },
                React.createElement(AccordionWrapper, { examType: "OTHER_REQUIREMENTS", examTitle: "Other Requirements", courseDetails: courseDetails }))) : null)));
};
export default AdditionalExamRequirement;
//# sourceMappingURL=AdditionalExamRequirement.js.map